// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'lock-closed-solid';

export const Component = () => (
  <path d='M17.746 10.818h1.484c.432 0 .767.144 1.054.431.288.288.432.623.432 1.006v9.865c0 .432-.144.767-.432 1.054a1.408 1.408 0 0 1-1.054.431H5.485a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 4 22.12v-9.865c0-.383.144-.72.431-1.006a1.411 1.411 0 0 1 1.054-.431H6.97V6.412c0-1.485.526-2.73 1.532-3.832C9.556 1.527 10.85 1 12.334 1s2.778.527 3.83 1.58c1.055 1.054 1.581 2.347 1.581 3.832v4.406h.001ZM7.928 6.413v4.406h8.86V6.412c0-1.197-.431-2.25-1.34-3.113-.91-.91-1.916-1.34-3.114-1.34-1.197 0-2.203.43-3.113 1.34-.862.862-1.293 1.916-1.293 3.113Zm5.077 10.583a.946.946 0 0 0-.67-.287.946.946 0 0 0-.67.287.976.976 0 0 0-.288.719v1.963c0 .24.096.479.287.67a.946.946 0 0 0 .67.288.94.94 0 0 0 .67-.288.946.946 0 0 0 .288-.67v-1.963a.977.977 0 0 0-.287-.719Z' />
);

export const viewBox = '0 0 25 25';
